module.exports = __webpack_public_path__ + "897c597a.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/004-creativity.png
// module id = 1469
// module chunks = 4